module.exports = __webpack_public_path__ + "media/img/frontend_application/star-ee1ad6bebc22da5b2555d68c07970972.png";